<div id="wall-display-widget-config">
  <header>{{ headerLabel | translate | uppercase }}</header>
  <section>
    <ng-template #widgetConfigTemplate />
  </section>
  <footer>
    @if (showCloseButton) {
      <button
        type="button"
        class="button is-secondary is-medium"
        (click)="state.hideWidgetConfigForm()">
        {{ 'MAP-DISPLAY.CLOSE' | translate }}
      </button>
    }
    <button
      type="button"
      class="button is-primary is-medium"
      (click)="applyConfigSettings()">
      {{ 'MAP-DISPLAY.APPLY' | translate }}
    </button>
  </footer>
</div>
